module.exports = __webpack_public_path__ + "static/media/tools-audio2.ed7c6dd8.svg";